import React, { cloneElement } from "react";
import Toggle from "./Toggle.jsx";

export default function Togglebox({ onChange, items, selected = [] }) {
	return (
		<Togglebox.Options onChange={onChange} selected={selected}>
			{items.map((item) => (
				<Toggle key={item.id} {...item} />
			))}
		</Togglebox.Options>
	);
}

function ToggleboxOptions({ children, selected, ...rest }) {
	const arrChildren = React.Children.toArray(children).map((child) => {
		return cloneElement(child, {
			...rest,
			selected: selected.includes(child.props?.id),
		});
	});
	return <div className="togglebox">{arrChildren}</div>;
}

Togglebox.Options = ToggleboxOptions;
